import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../../shared';
import { RouterModule } from '@angular/router';
import { GERMPLASM_ATTRIBUTE_ROUTES } from './germplasm-attribute.route';
import { GermplasmAttributeContext } from './germplasm-attribute.context';
import { GermplasmAttributeModalComponent, GermplasmAttributePopupComponent } from './germplasm-attribute-modal.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...GERMPLASM_ATTRIBUTE_ROUTES]),
    ],
    declarations: [
        GermplasmAttributeModalComponent,
        GermplasmAttributePopupComponent
    ],
    providers: [
        GermplasmAttributeContext
    ]
})
export class GermplasmAttributeModule {
}
